import { render, staticRenderFns } from "./FAD.vue?vue&type=template&id=995a0458"
import script from "./FAD.vue?vue&type=script&lang=js"
export * from "./FAD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('995a0458')) {
      api.createRecord('995a0458', component.options)
    } else {
      api.reload('995a0458', component.options)
    }
    module.hot.accept("./FAD.vue?vue&type=template&id=995a0458", function () {
      api.rerender('995a0458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificacionesdigital/FAD.vue"
export default component.exports